import { useAsync } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';

import { azureResourcesApiRef } from '../api';

export type AzureOwnGroup = {
  id: string;
  displayName?: string;
};

const EMPTY_GROUPS: AzureOwnGroup[] = [];

export const useAzureOwnGroups = (): {
  loading: boolean;
  error: Error | undefined;
  value: AzureOwnGroup[];
} => {
  const api = useApi(azureResourcesApiRef);
  const {
    value: groupsValue,
    loading,
    error,
  } = useAsync(async () => {
    const groups = await api.getAzureOwnGroups();
    return groups.value;
  }, []);

  return {
    value: groupsValue ?? EMPTY_GROUPS,
    loading,
    error,
  } as const;
};
